import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useKidStore } from '@entities/customer'
import { useKidInCustomer } from '@entities/customer'

import { useLessonRoomStore } from './store'
import { useRoomLiveKitChat } from './chat-live-kit.hook'
import { useRoomLiveKit } from './room-live-kit.hook'
import { trackClassroomEvent } from '../lib/classroom'

interface ClassroomChatReturn {
  isReady: ComputedRef<boolean>
  sendMessage: (text: string) => Promise<void>
  toggleChat: () => void
}

export const useClassroomChat = (): ClassroomChatReturn => {
  const lessonRoomStore = useLessonRoomStore()
  const kidStore = useKidStore()
  const { name: studentName } = useKidInCustomer({ kidId: kidStore.activeKidId })
  const { connectionState } = useRoomLiveKit()

  const { sendMessage } = useRoomLiveKitChat({
    getSenderName: () => studentName.value,
    onMessage: (m) => lessonRoomStore.addChatMessage(m),
    onSent: () => trackClassroomEvent('Form_submit', { name: 'chat' }),
  })

  const isReady = computed<boolean>(() => connectionState.value === 'connected')

  const toggleChat = (): void => {
    const next = !lessonRoomStore.isChatOpen
    lessonRoomStore.setChatOpen(next)
    if (next) lessonRoomStore.setChatUnread(false)
  }

  return {
    isReady,
    sendMessage,
    toggleChat,
  }
}
